import { Phone, AlertTriangle, PhoneOff } from "lucide-react";

// One at-a-glance pill for whether a teammate can actually receive text/call alerts.
// Green = verified mobile (reachable); amber = number on file but unconfirmed; grey = no mobile.
// Used across Team and Emergency so a reachability gap is obvious everywhere.
export function ReachabilityBadge({ phoneVerified, hasPhone, callOk = true }) {
  if (phoneVerified && hasPhone && !callOk) {
    return (
      <span data-testid="calls-off-badge"
        title="Verified mobile, but this person switched emergency calls off (Account → Notifications) — texted and emailed, not called"
        className="inline-flex items-center gap-1 rounded-full bg-sky-50 text-sky-800 text-[10px] font-bold px-2 py-0.5 whitespace-nowrap">
        <PhoneOff className="h-3 w-3" strokeWidth={2.5} /> Text + email · calls off
      </span>
    );
  }
  if (phoneVerified && hasPhone) {
    return (
      <span data-testid="reachable-badge"
        title="Verified mobile — can be texted and called for alerts"
        className="inline-flex items-center gap-1 rounded-full bg-emerald-50 text-emerald-700 text-[10px] font-bold px-2 py-0.5 whitespace-nowrap">
        <Phone className="h-3 w-3" strokeWidth={2.5} /> Reachable
      </span>
    );
  }
  if (hasPhone) {
    return (
      <span data-testid="unverified-badge"
        title="Number on file but not verified — emergency alerts are texted and emailed, not called, until it's verified"
        className="inline-flex items-center gap-1 rounded-full bg-amber-50 text-amber-700 text-[10px] font-bold px-2 py-0.5 whitespace-nowrap">
        <AlertTriangle className="h-3 w-3" strokeWidth={2.5} /> Unverified · text+email only
      </span>
    );
  }
  return (
    <span data-testid="no-mobile-badge"
      title="No mobile on file — can't receive text or call alerts"
      className="inline-flex items-center gap-1 rounded-full bg-sand-100 text-ink/70 text-[10px] font-bold px-2 py-0.5 whitespace-nowrap">
      <PhoneOff className="h-3 w-3" strokeWidth={2.5} /> No mobile
    </span>
  );
}
